import React from 'react';
import CalendarDays from 'lucide-react/dist/esm/icons/calendar-days.js';
import { formatCompactDrawDateTime } from '../utils/dateFormat';

export default function DrawCountdownHeader({
  draw,
  date,
  children,
  label = 'Draw In',
  className = '',
  dateClassName = '',
  labelClassName = '',
  dateStyle,
  labelStyle,
  showIcon = true,
}) {
  const formattedDateTime = formatCompactDrawDateTime(date ?? draw);

  return (
    <div className={`text-center ${className}`}>
      <div
        className={`text-xs font-semibold uppercase tracking-wider ${formattedDateTime ? 'mb-1.5' : ''} ${labelClassName}`}
        style={labelStyle}
      >
        {children || label}
      </div>
      {formattedDateTime && (
        <div
          className={`mx-auto inline-flex max-w-full items-center justify-center gap-1.5 rounded-full border border-white/25 bg-white/15 px-3 py-1.5 text-sm font-bold uppercase tracking-[0.08em] text-white shadow-sm backdrop-blur sm:text-base ${dateClassName}`}
          style={dateStyle}
        >
          {showIcon && <CalendarDays className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />}
          <span className="truncate">{formattedDateTime}</span>
        </div>
      )}
    </div>
  );
}
